import React from 'react';
import WhoAmIContent from '../components/WhoAmIContent';

const WhoAmI = () => {
  return <WhoAmIContent />;
};

export default WhoAmI;
